<div
  class="ahe-ui form-group"
  [class.has-feedback]="hasFeedback()"
  [class.has-success]="success()"
  [class.has-error]="error()"
>
  @if (label()) {
    <label [attr.for]="id()" [class.disabled]="isDisabled()">
      {{ label() }}@if (required()) {<span class="required"> *</span>}
    </label>
  }

  <input
    #input
    class="form-control"
    [class.has-icon]="!!icon()"
    type="text"
    [value]="currentValue()"
    [attr.id]="id()"
    [attr.disabled]="isDisabled() ? '' : null"
    [attr.maxlength]="maxlength()"
    [attr.placeholder]="placeholder()"
    [attr.required]="required() ? '' : null"
    [attr.aria-describedby]="describedBy()"
    [attr.aria-invalid]="ariaInvalid()"
    (focus)="onFocus($event)"
    (blur)="onBlur($event, input.value)"
    (input)="onInput($event, input.value)"
  />
  @if (icon()) {
    <i [class]="'dpg-icon dpg-icon-' + icon()" aria-hidden="true"></i>
  }

  @if (hasFeedback()) {
    <span class="help-block" [attr.id]="helpBlockId()" aria-live="assertive">
      @if (error()) {
        <i class="dpg-icon dpg-icon-incorrect" aria-hidden="true"></i>
      }
      @if (success()) {
        <i class="dpg-icon dpg-icon-input-success" aria-hidden="true"></i>
      }
      <span>
        @for (message of feedback(); track $index) {
          <span>{{ message }}<br /></span>
        }
      </span>
    </span>
  }
</div>
